import { NotificationManager } from 'react-notifications'
import { getData, sendData, sendFormData } from './apiService.js'
export async function saveVisit(values, file) {
  let response = await sendFormData('visits/store', values, file)
  if (response.success) {
    NotificationManager.success('Saved')
    return true
  }
  NotificationManager.error(response.message)
  return false
}

export async function getVisits(params) {
  let response = await getData('visits/get', params)
  if (response.success) {
    return response.data
  } else {
    NotificationManager.error(response.message)
    return false
  }
}

export async function getVisit(params) {
  let response = await getData('visits/getEach', params)
  if (response.success) {
    return response.data
  } else {
    NotificationManager.error(response.message)
    return false
  }
}

export async function editVisit(values,file) {
  let response = await sendFormData('visits/update', values,file)
  if (response.success) {
    NotificationManager.success('Saved')
    return true
  }
  NotificationManager.error(response.message)
  return false
}

export async function deleteVisit(id) {
  let response = await sendData('visits/delete', { id: id })
  if (response.success) {
    NotificationManager.success('Delete')
    return true
  }
  NotificationManager.error(response.message)
  return false
}
